export default __webpack_public_path__ + "static/clientCrea-e268d5abcd69122602437d1ffdaf4327.svg";